import React from "react";

import styled from "styled-components";

const InterestedSection = () => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const targetElement = document.getElementById("contact-section");

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth", // This makes the scroll animation smooth
        block: "start" // Aligns the top of the element with the top of the viewport
      });
    } else {
      console.error(`Element with ID '${"contact-section"}' not found.`);
    }
  };

  return (
    <Wrapper id={"interested-section"}>
      <Container>
        <Content>
          <Heading>Interested in Majura?</Heading>
          <ButtonRow>
            <DemoButton onClick={handleClick}>Book a Demo</DemoButton>
            <JobLinkButton href="/careers">Apply for a Job</JobLinkButton>
          </ButtonRow>
        </Content>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  justify-content: center;
  display: flex;
  margin: 0;
  padding: 140px 24px;
  background: radial-gradient(ellipse at 50% 0%, rgba(76, 92, 240, 0.35) 0%, transparent 60%),
    #0a2472;

  @media (max-width: 1025px) {
    padding: 90px 24px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 900px;
`;

const Content = styled.div`
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.15;
  color: #ffffff;
  margin: 0;

  @media (max-width: 1025px) {
    font-size: 2.25rem;
    font-weight: 700;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 48px;

  @media (max-width: 1025px) {
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 40px;
    padding: 0 1rem;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BaseButton = styled.button`
  border-radius: 12px;
  font-weight: 600;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  width: fit-content;
  padding: 1rem 2.6rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }

  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 297.81px !important;
  }
`;

const DemoButton = styled(BaseButton)`
  background: #4c5cf0;
  color: white;
  box-shadow: 0 0 0 1px rgba(76, 92, 240, 0.6), 0 0 40px rgba(76, 92, 240, 0.55);

  &:hover {
    box-shadow: 0 0 0 1px rgba(76, 92, 240, 0.8), 0 0 56px rgba(76, 92, 240, 0.75);
  }
`;

const ButtonStyleMixin = `
  border-radius: 12px;
  font-weight: 600;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  width: fit-content;
  padding: 1rem 2.6rem;
  display: inline-block;
  box-sizing: border-box;
  transition: transform 0.15s ease, background 0.15s ease;

  @media (max-width: 767px) {
    width: 100% !important;
    max-width: 297.81px !important;
  }
`;

// Now, style the 'a' tag directly
const JobLinkButton = styled.a`
  ${ButtonStyleMixin}
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  line-height: normal;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: white;
  }
`;

export default InterestedSection;
